export default "__VITE_ASSET__Bs9PQyjJ__"